<template>
  <Teleport to="body">
    <!-- class="fixed inset-0 z-[9999] bg-black bg-opacity-50 flex items-center justify-center" -->
    <div
      v-if="visible"
      class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-[9999]"
    >
      <div class="bg-gray-200 w-[550px] rounded-lg shadow-lg p-1">
        <div class="bg-red-400 text-red-600 font-bold text-lg mb-2 p-2">
          {{ title }}
        </div>
        <div class="bg-gray-200 text-gray-700 mb-6 p-2">{{ message }}</div>
        <div class="flex justify-end space-x-2 p-3">
          <button
            class="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600"
            @click="handleConfirm"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted } from "vue";

const props = defineProps({
  title: String,
  message: String,
  onConfirmCallback: Function,
});

const visible = ref(true);

function close() {
  visible.value = false;
  // DOM에서 직접 제거 (부모가 동적 생성했을 경우만 필요)
  if (typeof window !== "undefined") {
    const el = document.querySelector("[data-confirm-dialog]");
    el?.parentNode?.removeChild(el);
  }
}

function handleConfirm() {
  if (props.onConfirmCallback) props.onConfirmCallback();
  close();
}
</script>
